import React from 'react';
import { User } from '../types';
import { PACOCA_URL } from '../utils/vars';

interface ImgVerifiedProps {
  user?: User | null; // Propriedade opcional
  classNameProp?: string; // Propriedade opcional
}

const ImgVerified: React.FC<ImgVerifiedProps> = ({ user, classNameProp }) => {
  return (
      <span className='span-img-verified'>
        {/* {user?.id == 1 || user?.id == 2 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/pacoca-sem-braco.png" loading="lazy"/>
          </>
        ) : null} */}
        {user?.stamps?.includes("black")  ? (
          <>
            <img className={`${classNameProp} img-vefified-company-color`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/black.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("hidden_deficiencies")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/hidden_deficiencies.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("brown")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/brown.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("autism")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/autism.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("lgbt")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/lgbt.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("gray")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/gray.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("yellow")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/yellow.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("purple")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/purple.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("blue")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/verified.png`} loading="lazy"/>
          </>
        ) : null}


        {user?.position === 1 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/brown.png`} loading="lazy"/>
          </>
        ) : null}
        {user?.position === 2 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/darkBlue.png`} loading="lazy"/>
          </>
        ) : null}

        {user?.position === 3 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/red.png`} loading="lazy"/>
          </>
        ) : null}
       
        {user?.position === 4 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/peach.png`} loading="lazy"/>
          </>
        ) : null}

        {/* {user?.position === 4 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/staff.png`} loading="lazy"/>
          </>
        ) : null}

        {user?.position === 5 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src={`${PACOCA_URL}/img/selos/help.png`} loading="lazy"/>
          </>
        ) : null} */}
      </span>
  );
}

export default ImgVerified;
